module.exports = __webpack_public_path__ + "static/media/lalashan_package.8f3a5205.png";